<!-- footer -->
<div class="footer">
  <div class="f-card">
    <div class="content">
      <div class="logo">
        <a href="/">
          <img src="../../../../assets/img/logo2.png" alt="" />
        </a>
      </div>
    </div>
    <div class="huiospay">
      <h3>HuiosPay</h3>
      <div class="list">
        <li><a href="why-huiospay">Why HuiosPay</a></li>
        <li><a href="developer-section">Developer</a></li>
        <li><a href="about-us">Company</a></li>
        <li><a href="contact-us">Support</a></li>
        <li><a href="become-merchant">Become a Merchant</a></li>
        <!-- <li><a href="#">Pricing</a></li> -->
        <li>
          <a href="https://online-banking.huiospay.com/" target="_blank"
            >Payment Gateway</a
          >
          <!-- <a href="https://huiospay-payment-gateway.netlify.app/" target="_blank"
            >Payment Gateway</a
          > -->
        </li>
        <li><a href="https://www.payslate.com.ng" target="_blank">Payslate</a></li>
        <!-- <li><a href="https://user.payslate.com.ng" target="_blank">Payslate for user</a></li> -->
        <!-- <li><a href="https://organization.payslate.com.ng/" target="_blank">Payslate for organization</a></li>
            <li><a href="https://staff.payslate.com.ng/" target="_blank">Payslate for staff</a></li>
            <li><a href="#">Login/Sign Up</a></li> -->
      </div>
    </div>
    <div class="huiospay">
      <h3>Legal</h3>
      <div class="list">
        <li><a href="cookies-policy">Cookies Policy</a></li>
        <li><a href="privacy-policy">Privacy Policy</a></li>
        <li><a href="terms-and-conditions">Terms & Conditions</a></li>
        <li><a href="data-protection">Data Protection</a></li>
        <li (click)="downloadFile()">
          <!-- <a href=""> -->
            Merchant Service Agreement

          <!-- </a> -->
        </li>
        <li><a href="faqs">FAQs</a></li>
      </div>
    </div>

    <div class="huiospay">
      <h3>Contact</h3>
      <div class="list">
        <!-- <li>Plot 86, Cadastral Zone B06, Mabushi District, Abuja</li> -->
        <li>
          Suites A4, 1st floor, AP Plaza, 28 Adetokunbo Ademola Cresent Wuse 2, Abuja
        </li>
        <li><a href="mailto:hello@gmail.com">contactus@huiospay.com</a></li>
        <li><a href="tel: +2348037086670"> 08037086670 </a></li>
      </div>
      <div class="social">
        <li>
          <a href="https://x.com/huiospay?t=LsnpnlD8ZoINt3FJO30ySA&s=08" target="_blank">
            <app-font-icon
              iconType="remix"
              iconName="twitter-fill"
              iconSize="small"
              iconColor="var(--footer-icon-blue)"
            >
            </app-font-icon>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/huiospay/mycompany/" target="_blank">
            <app-font-icon
              iconType="remix"
              iconName="linkedin-fill"
              iconSize="small"
              iconColor="var(--footer-icon-blue)"
            >
            </app-font-icon>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/profile.php?id=100083160070956" target="_blank">
          <app-font-icon
            iconType="remix"
            iconName="facebook-fill"
            iconSize="small"
            iconColor="var(--footer-icon-blue)"
          >
          </app-font-icon>
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/huiospay_ng/" target="_blank">
            <app-font-icon
              iconType="remix"
              iconName="instagram-line"
              iconSize="small"
              iconColor="var(--footer-icon-blue)"
            >
            </app-font-icon>
          </a>
        </li>
      </div>
    </div>
  </div>
  <div class="footbase">
    <p>
      Copyright &copy; 2020 - {{finalYear}}, HuiosPay. All rights reserved. Powered by
      HuiosPay
    </p>
  </div>
</div>
<!-- End Footer-->
